module.exports = __webpack_public_path__ + "img/gn.798b298a.svg";